export default function Certificates() {
    return (
        <div className="Certificates" id="Certificates" data-aos="fade-up" data-aos-duration="2000">
            <h3 className="text-center">Certifications</h3>
          <ul>
              <li> <a href="https://www.credly.com/badges/f04a3e6f-b447-4d1f-9ebd-cc3557c22667">AWS Certified Cloud Practitioner</a> Issued by Amazon Web Services Training and Certification on September 22, 2024</li>
             <li> <a href="https://www.udemy.com/certificate/UC-45ecca95-9c72-418f-b01c-4000157d410b">Python : Master Programming and Development with 15 Projects</a> Issued by Udemy on Jan 3rd, 2025</li>
              <li> <a href="https://www.coursera.org/account/accomplishments/verify/DBQ92D39TUWF">Front-End Web Development with React</a> Issued by The Hong Kong University of Science and Technology on July 3, 2020</li>
              <li> <a href="https://www.coursera.org/account/accomplishments/verify/DC6VCDSD6C5R">Multiplatform Mobile App Development with React Native</a>  Issued by The Hong Kong University of Science and Technology on July 9, 2020</li>
              <li> <a href="https://www.udemy.com/certificate/UC-ede799b1-df0a-4f47-91d9-6278b98b78a5">Android Application Development</a>issued by  ProgramMe Programming on May 2, 2020</li> 
          </ul>
          
        </div>
    )
}
